import SendEmail from './SendEmail';

export default SendEmail;
